/**
 * @file 日期相关
 */
import { moment, Formatter } from '@seiue/moment';
/**
 * 获取用于日期选择器展示的 Format，这里我们隐藏了秒
 * @param format
 * @param showTime
 * @returns
 */
export const getDatePickerDisplayFormat = (format, showTime) => showTime
    ? format
        ? format === null || format === void 0 ? void 0 : format.replace(':ss', '')
        : 'YYYY-MM-DD HH:mm'
    : undefined;
/**
 * 用我们的 moment，来重新格式化日期选择器 OnChange 回传的参数，用于规范一些类似时区，多语言等内容。
 *
 * @param date - 日期选择器所回传的 moment
 * @param format - 指定的格式化方法
 * @returns - [moment，dateString]
 */
export const formatDatePickerOnChangeReturnValue = (date, format, showTime) => {
    if (!date)
        return [date, ''];
    return [
        moment(date),
        moment(date).format(format || (showTime ? Formatter.DateFullTime : 'YYYY-MM-DD')),
    ];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9EYXRlUGlja2VyL2RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxPQUFPLEVBQVUsTUFBTSxFQUFFLFNBQVMsRUFBRSxNQUFNLGVBQWUsQ0FBQTtBQUV6RDs7Ozs7R0FLRztBQUNILE1BQU0sQ0FBQyxNQUFNLDBCQUEwQixHQUFHLENBQ3hDLE1BQWUsRUFDZixRQUFrQixFQUNsQixFQUFFLENBQ0YsUUFBUTtJQUNOLENBQUMsQ0FBQyxNQUFNO1FBQ04sQ0FBQyxDQUFDLE1BQU0sYUFBTixNQUFNLHVCQUFOLE1BQU0sQ0FBRSxPQUFPLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQztRQUM1QixDQUFDLENBQUMsa0JBQWtCO0lBQ3RCLENBQUMsQ0FBQyxTQUFTLENBQUE7QUFFZjs7Ozs7O0dBTUc7QUFDSCxNQUFNLENBQUMsTUFBTSxtQ0FBbUMsR0FBRyxDQUNqRCxJQUFtQixFQUNuQixNQUFlLEVBQ2YsUUFBa0IsRUFDbEIsRUFBRTtJQUNGLElBQUksQ0FBQyxJQUFJO1FBQUUsT0FBTyxDQUFDLElBQUksRUFBRSxFQUFFLENBQVUsQ0FBQTtJQUVyQyxPQUFPO1FBQ0wsTUFBTSxDQUFDLElBQUksQ0FBQztRQUNaLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxNQUFNLENBQ2pCLE1BQU0sSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLENBQzdEO0tBQ08sQ0FBQTtBQUNaLENBQUMsQ0FBQSJ9